import { gql } from 'apollo-angular';

const SET_MIX_STATUS = gql`
  mutation updateMixStatus($mixStatus: MixStatus!, $purchasePlanId: Long!) {
    updateMixStatus(
      updateMixStatusRequest: {
        mixStatus: $mixStatus
        purchasePlanId: $purchasePlanId
      }
    ) {
      updated
    }
  }
`;

export default SET_MIX_STATUS;
